import React from 'react';
import { formatTimePanama } from '../utils/agendaDates';

const LOCATION_LABELS = {
    precise: 'Ubicación registrada · buena precisión',
    approximate: 'Ubicación registrada · precisión aproximada',
    unavailable: 'Ubicación no disponible'
};

const UNAVAILABLE_REASON_LABELS = {
    permissionDenied: 'permiso denegado',
    positionUnavailable: 'señal no disponible',
    timeout: 'tiempo de espera agotado',
    unsupported: 'navegador incompatible',
    unknown: 'error desconocido'
};

const finiteCoordinate = (value) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : null;
};

const ExecutionLocationDetails = ({ label, location }) => {
    if (!location) {
        return (
            <div className="text-sm text-color-secondary">
                <strong>{label}:</strong> Sin registro de ubicación
            </div>
        );
    }

    const latitude = finiteCoordinate(location.latitude);
    const longitude = finiteCoordinate(location.longitude);
    const hasCoordinates = latitude !== null && longitude !== null;
    const mapsUrl = hasCoordinates
        ? `https://www.google.com/maps?q=${encodeURIComponent(`${latitude},${longitude}`)}`
        : null;
    const statusLabel = LOCATION_LABELS[location.status] || 'Sin registro de ubicación';
    const reasonLabel = UNAVAILABLE_REASON_LABELS[location.unavailableReason];

    return (
        <div className="text-sm text-color-secondary">
            <strong>{label}:</strong> {statusLabel}
            {hasCoordinates ? ` · ${latitude.toFixed(5)}, ${longitude.toFixed(5)}` : ''}
            {location.accuracyMeters ? ` · precisión aprox. ${Math.round(location.accuracyMeters)} m` : ''}
            {reasonLabel ? ` · ${reasonLabel}` : ''}
            {location.recordedAt ? ` · ${formatTimePanama(location.recordedAt)}` : ''}
            {mapsUrl ? (
                <>
                    {' · '}
                    <a href={mapsUrl} target="_blank" rel="noopener noreferrer">
                        Ver en Google Maps
                    </a>
                </>
            ) : null}
            {location.unavailableNote ? (
                <div className="mt-1"><strong>Justificación:</strong> {location.unavailableNote}</div>
            ) : null}
        </div>
    );
};

export default ExecutionLocationDetails;
